export default __webpack_public_path__ + "assets/file-component.0ca75be7.svg";